import { Layer } from 'effect';

import { ZoneLayer } from './CommonLayer';
import { HttpClientLayer } from './HttpClientLayer';
import { EngineShellConfigProviderLayer, EngineShellServicesLayer } from '../ShellPlatform';
import { RefreshLock } from '../../service/auth/RefreshLock';
import { BrandFilterService } from '../../service/productFilter/BrandFilterService';
import { CheckboxFilterService } from '../../service/productFilter/CheckboxFilterService';
import { RangeFilterService } from '../../service/productFilter/RangeFilterService';
import { TaxonFilterService } from '../../service/productFilter/TaxonFilterService';
import { TextFilterService } from '../../service/productFilter/TextFilterService';
import { WarehouseFilterService } from '../../service/productFilter/WarehouseFilterService';
import { BalikovnaWidgetLive } from '../../service/balikovna/balikovnaWidgetLive';
import { PacketaWidgetLive } from '../../service/packeta/packetaWidgetLive';
import { PplWidgetLive } from '../../service/ppl/pplWidgetLive';
import { SlovakPostWidgetLive } from '../../service/slovakPost/slovakPostWidgetLive';
import { SupportBox } from '../../service/supportBox/SupportBox';

const FilterServicesLayer = Layer.mergeAll(
  CheckboxFilterService.layer,
  RangeFilterService.layer,
  TextFilterService.layer,
  BrandFilterService.layer,
  WarehouseFilterService.layer,
  TaxonFilterService.layer
);

/**
 * Complete client layer owned by the portable engine. Shell-only Live
 * implementations enter through the two deferred ShellPlatform layers.
 */
export const CoreEngineServicesLayer = Layer.empty.pipe(
  Layer.provideMerge(ZoneLayer),
  Layer.provideMerge(RefreshLock.layer),
  Layer.provideMerge(FilterServicesLayer),
  Layer.provideMerge(SupportBox.Live),
  Layer.provideMerge(BalikovnaWidgetLive),
  Layer.provideMerge(PacketaWidgetLive),
  Layer.provideMerge(PplWidgetLive),
  Layer.provideMerge(SlovakPostWidgetLive),
  Layer.provideMerge(HttpClientLayer)
);

export const CoreEngineLayerClient = CoreEngineServicesLayer.pipe(
  Layer.provideMerge(EngineShellServicesLayer),
  // `provideMerge`, not `provide`: `ConfigProvider` is a `Context.Reference`
  // with a `process.env` default. Effects the runtime runs later (GTM id,
  // Packeta key, Slovak Post token) read config too, and a provider consumed by
  // layer construction alone leaves them on the default, which in a browser
  // bundle carries none of the agnostic `ConfigKey.*` names.
  Layer.provideMerge(EngineShellConfigProviderLayer)
);

export type CoreEngineLayerClient = typeof CoreEngineLayerClient;
export type CoreEngineServicesLayer = typeof CoreEngineServicesLayer;
